import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { BillAddress } from '@/class/model/mdm/BillAddress'
import { Message } from '@/utils/Message'
import $store from '@/store'

/**
 * 收发通地址通用的 presentation model 致力于解决，所有帮助到代码选择功能的页面。
 */
export class BillAddressCommonPM {
  constructor(view) {
    this._job = null
    this._isPortFilter = true
    this._isMBL = false
    this._shipperField = 'shipperLine'
    this._consigneeField = 'consigneeLine'
    this._notifyField = 'notifyLine'
    this._shipperCodeField = 'shipperCode'
    this._consigneeCodeField = 'consigneeCode'
    this._notifyCodeField = 'notifyCode'

    this._checkShipper = true
    this._checkConsignee = true
    this._checkNotify = true
    this._copyAddrType = 'SE'
    this._viewFromBasic = false // 是否从基本页签发起的请求
    this._view = view
  }

  get view() {
    return this._view
  }

  set view(value) {
    this._view = value
  }

  get job() {
    return this._job
  }

  set job(value) {
    this._job = value
  }

  get isPortFilter() {
    return this._isPortFilter
  }

  set isPortFilter(value) {
    this._isPortFilter = value
  }

  get isMBL() {
    return this._isMBL
  }

  set isMBL(value) {
    this._isMBL = value
  }

  get shipperField() {
    return this._shipperField
  }

  set shipperField(value) {
    this._shipperField = value
  }

  get consigneeField() {
    return this._consigneeField
  }

  set consigneeField(value) {
    this._consigneeField = value
  }

  get notifyField() {
    return this._notifyField
  }

  set notifyField(value) {
    this._notifyField = value
  }

  get shipperCodeField() {
    return this._shipperCodeField
  }

  set shipperCodeField(value) {
    this._shipperCodeField = value
  }

  get consigneeCodeField() {
    return this._consigneeCodeField
  }

  set consigneeCodeField(value) {
    this._consigneeCodeField = value
  }

  get notifyCodeField() {
    return this._notifyCodeField
  }

  set notifyCodeField(value) {
    this._notifyCodeField = value
  }

  get checkShipper() {
    return this._checkShipper
  }

  set checkShipper(value) {
    this._checkShipper = value
  }

  get checkConsignee() {
    return this._checkConsignee
  }

  set checkConsignee(value) {
    this._checkConsignee = value
  }

  get checkNotify() {
    return this._checkNotify
  }

  set checkNotify(value) {
    this._checkNotify = value
  }
  /**
   * 抄录类型
   */
  // [Inspectable(category="General", enumeration="SE,SI,AE,AI,MBL,MBL2,HBL,HBL2", defaultValue="SE")]
  get copyAddrType() {
    return this._copyAddrType
  }

  set copyAddrType(value) {
    this._copyAddrType = value
  }

  get viewFromBasic() {
    return this._viewFromBasic
  }

  set viewFromBasic(value) {
    this._viewFromBasic = value
  }

  // public var billAddressWindow:BillAddressWindow; 请使用 独立组件 src/components/Cargo/Job/billAddressDialog.vue

  /**
 * SE	MBL		直单		客户 		目的港
 * SE	MBL 	非直单		目的港代理	目的港
 * SE 	HBL 			客户 		目的港
 * AE	MAWB	一对多		目的港代理	目的港
 * AE	MAWB 	一对一		目的港代理	目的港
 * AE	MAWB	直单		客户		目的港
 * AE	HAWB			客户		目的港
 */
  getPartnerDest() {
    var customerId = 0
    var destPort = ''
    const job = this.job
    if (job.lob === 'SE' || job.lob === 'SI') {
      if (this.isMBL && job.mblOnly) {
        customerId = job.customerId
        destPort = job.destinationPortCode
      } else if (this.isMBL) {
        customerId = job.destinationAgent
        destPort = job.destinationPortCode
      } else {
        customerId = job.customerId
        destPort = job.destinationPortCode
      }
    } else if (job.lob === 'AE') {
      const ae = job
      if (this.isMBL) {
        if (ae.operateType === AirExportConstants.CONSOLE.code || ae.operateType === AirExportConstants.BACK_TO_BACK.code) {
          customerId = job.destinationAgent
          destPort = job.destinationPortCode
        } else if (ae.operateType === AirExportConstants.DIRECT.code) {
          customerId = job.customerId
          destPort = job.destinationPortCode
        }
      } else {
        customerId = job.customerId
        destPort = job.destinationPortCode
      }
    } else if (job.lob === 'AI') {
      customerId = job.customerId
      destPort = job.destinationPortCode
    } else if (job.lob === 'RE' || job.lob === 'RI') {
      customerId = job.customerId
      destPort = ' '
    } else if (job.lob === 'IE') {
      customerId = job.customerId
      destPort = job.destinationPortCode
    }
    return [customerId, destPort]
  }

  /**
 * 保存
 */
  saveCheck() {
    const job = this.job
    const view = this.view
    if (!job) { return }
    if (job.lob === 'RE' || job.lob === 'RI') {
      if (job.customerId === 0) { return }
    } else {
      if (job.customerId === 0 || job.destinationPortCode === null || job.destinationPortCode === '') { return }
    }
    if (this.checkShipper && view.$refs.shipperLine1 && view.$refs.shipperLine1[0] && (!view.$refs.shipperLine1[0].value || !view.$refs.shipperLine1[0].value.trim())) { return }
    if (this.checkConsignee && view.$refs.consigneeLine1 && view.$refs.consigneeLine1[0] && (!view.$refs.consigneeLine1[0].value || !view.$refs.consigneeLine1[0].value.trim())) { return }
    if (!this.viewFromBasic) {
      if (this.checkNotify && view.$refs.notifyLine1 && view.$refs.notifyLine1[0] && (!view.$refs.notifyLine1[0].value || !view.$refs.notifyLine1[0].value.trim())) { return }
    }
    let shipperCode = ''
    let consigneeCode = ''
    let notifyCode = ''
    if (view.$refs.shipperCode) { shipperCode = view.$refs.shipperCode.value }
    if (view.$refs.consigneeCode) { consigneeCode = view.$refs.consigneeCode.value }
    if (view.$refs.notifyCode) { notifyCode = view.$refs.notifyCode.value }

    const addr = new BillAddress().fillDefaultValue()
    const partnerDest = this.getPartnerDest()
    addr.billHistoryType = 0
    addr.partnerId = partnerDest[0]
    addr.pod = partnerDest[1]
    addr.lob = job.lob
    addr.officeId = $store.getters.currentOfficeId
    addr.shipperCode = shipperCode
    addr.consigneeCode = consigneeCode
    addr.notifyCode = notifyCode

    if (job.manifestInfos != null && job.manifestInfos.length > 0) {
      for (var manifestInfo of job.manifestInfos) {
        addr.shipperShortCode = manifestInfo === null ? '' : manifestInfo.shipperShortCode
        addr.shipperEnterpriseCode = manifestInfo === null ? '' : manifestInfo.shipperEnterpriseCode
        addr.shipperEnterpriseName = manifestInfo === null ? '' : manifestInfo.shipperEnterpriseName
        addr.shipperAddress = manifestInfo === null ? '' : manifestInfo.shipperAddress
        addr.shipperContactsType = manifestInfo === null ? 0 : manifestInfo.shipperContactsType
        addr.shipperContacts = manifestInfo === null ? '' : manifestInfo.shipperContacts
        addr.shipperCityName = manifestInfo === null ? '' : manifestInfo.shipperCityName
        addr.shipperProvinceCode = manifestInfo === null ? '' : manifestInfo.shipperProvinceCode
        addr.shipperProvinceName = manifestInfo === null ? '' : manifestInfo.shipperProvinceName
        addr.shipperZipCode = manifestInfo === null ? '' : manifestInfo.shipperZipCode
        addr.shipperCountryCode = manifestInfo === null ? '' : manifestInfo.shipperCountryCode
        addr.shipperAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.shipperAeoEnterpriseCode

        addr.isInstructBill = manifestInfo === null ? false : manifestInfo.isInstructBill
        addr.consigneeShortCode = manifestInfo === null ? '' : manifestInfo.consigneeShortCode
        addr.consigneeEnterpriseCode = manifestInfo === null ? '' : manifestInfo.consigneeEnterpriseCode
        addr.consigneeEnterpriseName = manifestInfo === null ? '' : manifestInfo.consigneeEnterpriseName
        addr.consigneeAddress = manifestInfo === null ? '' : manifestInfo.consigneeAddress
        addr.consigneeContactsType = manifestInfo === null ? 0 : manifestInfo.consigneeContactsType
        addr.consigneeContacts = manifestInfo === null ? '' : manifestInfo.consigneeContacts
        addr.consigneeCityName = manifestInfo === null ? '' : manifestInfo.consigneeCityName
        addr.consigneeProvinceCode = manifestInfo === null ? '' : manifestInfo.consigneeProvinceCode
        addr.consigneeProvinceName = manifestInfo === null ? '' : manifestInfo.consigneeProvinceName
        addr.consigneeZipCode = manifestInfo === null ? '' : manifestInfo.consigneeZipCode
        addr.consigneeCountryCode = manifestInfo === null ? '' : manifestInfo.consigneeCountryCode
        addr.consigneeAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.consigneeAeoEnterpriseCode
        addr.consigneeSpecificContacts = manifestInfo === null ? '' : manifestInfo.consigneeSpecificContacts
        addr.consigneeSpecificContactsName = manifestInfo === null ? '' : manifestInfo.consigneeSpecificContactsName
        addr.consigneeSpecificContactsType = manifestInfo === null ? 0 : manifestInfo.consigneeSpecificContactsType

        addr.notifyShortCode = manifestInfo === null ? '' : manifestInfo.notifyShortCode
        addr.notifyEnterpriseCode = manifestInfo === null ? '' : manifestInfo.notifyEnterpriseCode
        addr.notifyEnterpriseName = manifestInfo === null ? '' : manifestInfo.notifyEnterpriseName
        addr.notifyAddress = manifestInfo === null ? '' : manifestInfo.notifyAddress
        addr.notifyContactsType = manifestInfo === null ? 0 : manifestInfo.notifyContactsType
        addr.notifyContacts = manifestInfo === null ? '' : manifestInfo.notifyContacts
        addr.notifyCityName = manifestInfo === null ? '' : manifestInfo.notifyCityName
        addr.notifyProvinceCode = manifestInfo === null ? '' : manifestInfo.notifyProvinceCode
        addr.notifyProvinceName = manifestInfo === null ? '' : manifestInfo.notifyProvinceName
        addr.notifyZipCode = manifestInfo === null ? '' : manifestInfo.notifyZipCode
        addr.notifyCountryCode = manifestInfo === null ? '' : manifestInfo.notifyCountryCode
        addr.notifyAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.notifyAeoEnterpriseCode
      }
    }

    if (view.$refs.shipperLine1 && view.$refs.shipperLine1[0]) {
      addr.shipperLine1 = view.$refs.shipperLine1[0].value
      addr.shipperLine2 = view.$refs.shipperLine2[0].value
      addr.shipperLine3 = view.$refs.shipperLine3[0].value
      addr.shipperLine4 = view.$refs.shipperLine4[0].value
      addr.shipperLine5 = view.$refs.shipperLine5[0].value
      addr.shipperLine6 = view.$refs.shipperLine6[0].value
      // 增加第 7 行
      if (view.$refs.shipperLine7 && view.$refs.shipperLine7[0]) {
        addr.shipperLine7 = view.$refs.shipperLine7[0].value
      }
    }

    if (view.$refs.consigneeLine1 && view.$refs.consigneeLine1[0]) {
      addr.consigneeLine1 = view.$refs.consigneeLine1[0].value
      addr.consigneeLine2 = view.$refs.consigneeLine2[0].value
      addr.consigneeLine3 = view.$refs.consigneeLine3[0].value
      addr.consigneeLine4 = view.$refs.consigneeLine4[0].value
      addr.consigneeLine5 = view.$refs.consigneeLine5[0].value
      addr.consigneeLine6 = view.$refs.consigneeLine6[0].value
      // 增加第 7 行
      if (view.$refs.consigneeLine7 && view.$refs.consigneeLine7[0]) {
        addr.consigneeLine7 = view.$refs.consigneeLine7[0].value
      }
    }

    if (view.$refs.notifyLine1 && view.$refs.notifyLine1[0]) {
      addr.notifyLine1 = view.$refs.notifyLine1[0].value
      addr.notifyLine2 = view.$refs.notifyLine2[0].value
      addr.notifyLine3 = view.$refs.notifyLine3[0].value
      addr.notifyLine4 = view.$refs.notifyLine4[0].value
      addr.notifyLine5 = view.$refs.notifyLine5[0].value
      addr.notifyLine6 = view.$refs.notifyLine6[0].value
      // 增加第 7 行
      if (view.$refs.notifyLine7 && view.$refs.notifyLine7[0]) {
        addr.notifyLine7 = view.$refs.notifyLine7[0].value
      }
    }
    BillAddress.checkBillAddress(addr.getData()).then(res => {
      this.checkBillAddressResultHandler()
    }).catch(err => {
      this.commonFaultHandler()
    })
  }

  /**
   * 保存
   */
  aeSaveCheck() {
    const job = this.job
    const view = this.view
    if (!job) { return }
    if (job.customerId === 0 || job.destinationPortCode === null || job.destinationPortCode === '') { return }
    if (this.checkShipper && view.$refs.shipperLine1 && (!view.$refs.shipperLine1.value || !view.$refs.shipperLine1.value.trim())) { return }
    if (this.checkConsignee && view.$refs.consigneeLine1 && (!view.$refs.consigneeLine1.value || !view.$refs.consigneeLine1.value.trim())) { return }
    if (!this.viewFromBasic) {
      if (this.checkNotify && view.$refs.notifyLine1 && (!view.$refs.notifyLine1.value || !view.$refs.notifyLine1.value.trim())) { return }
    }
    let shipperCode = ''
    let consigneeCode = ''
    let notifyCode = ''
    if (view.$refs.shipperCode) { shipperCode = view.$refs.shipperCode.value }
    if (view.$refs.consigneeCode) { consigneeCode = view.$refs.consigneeCode.value }
    if (view.$refs.notifyCode) { notifyCode = view.$refs.notifyCode.value }

    const addr = new BillAddress().fillDefaultValue()
    const partnerDest = this.getPartnerDest()
    addr.billHistoryType = 0
    addr.partnerId = partnerDest[0]
    addr.pod = partnerDest[1]
    addr.lob = job.lob
    addr.officeId = $store.getters.currentOfficeId
    addr.shipperCode = shipperCode
    addr.consigneeCode = consigneeCode
    addr.notifyCode = notifyCode

    if (job.manifestInfos != null && job.manifestInfos.length > 0) {
      for (var manifestInfo of job.manifestInfos) {
        addr.shipperShortCode = manifestInfo === null ? '' : manifestInfo.shipperShortCode
        addr.shipperEnterpriseCode = manifestInfo === null ? '' : manifestInfo.shipperEnterpriseCode
        addr.shipperEnterpriseName = manifestInfo === null ? '' : manifestInfo.shipperEnterpriseName
        addr.shipperAddress = manifestInfo === null ? '' : manifestInfo.shipperAddress
        addr.shipperContactsType = manifestInfo === null ? 0 : manifestInfo.shipperContactsType
        addr.shipperContacts = manifestInfo === null ? '' : manifestInfo.shipperContacts
        addr.shipperCityName = manifestInfo === null ? '' : manifestInfo.shipperCityName
        addr.shipperProvinceCode = manifestInfo === null ? '' : manifestInfo.shipperProvinceCode
        addr.shipperProvinceName = manifestInfo === null ? '' : manifestInfo.shipperProvinceName
        addr.shipperZipCode = manifestInfo === null ? '' : manifestInfo.shipperZipCode
        addr.shipperCountryCode = manifestInfo === null ? '' : manifestInfo.shipperCountryCode
        addr.shipperAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.shipperAeoEnterpriseCode

        addr.isInstructBill = manifestInfo === null ? false : manifestInfo.isInstructBill
        addr.consigneeShortCode = manifestInfo === null ? '' : manifestInfo.consigneeShortCode
        addr.consigneeEnterpriseCode = manifestInfo === null ? '' : manifestInfo.consigneeEnterpriseCode
        addr.consigneeEnterpriseName = manifestInfo === null ? '' : manifestInfo.consigneeEnterpriseName
        addr.consigneeAddress = manifestInfo === null ? '' : manifestInfo.consigneeAddress
        addr.consigneeContactsType = manifestInfo === null ? 0 : manifestInfo.consigneeContactsType
        addr.consigneeContacts = manifestInfo === null ? '' : manifestInfo.consigneeContacts
        addr.consigneeCityName = manifestInfo === null ? '' : manifestInfo.consigneeCityName
        addr.consigneeProvinceCode = manifestInfo === null ? '' : manifestInfo.consigneeProvinceCode
        addr.consigneeProvinceName = manifestInfo === null ? '' : manifestInfo.consigneeProvinceName
        addr.consigneeZipCode = manifestInfo === null ? '' : manifestInfo.consigneeZipCode
        addr.consigneeCountryCode = manifestInfo === null ? '' : manifestInfo.consigneeCountryCode
        addr.consigneeAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.consigneeAeoEnterpriseCode
        addr.consigneeSpecificContacts = manifestInfo === null ? '' : manifestInfo.consigneeSpecificContacts
        addr.consigneeSpecificContactsName = manifestInfo === null ? '' : manifestInfo.consigneeSpecificContactsName
        addr.consigneeSpecificContactsType = manifestInfo === null ? 0 : manifestInfo.consigneeSpecificContactsType

        addr.notifyShortCode = manifestInfo === null ? '' : manifestInfo.notifyShortCode
        addr.notifyEnterpriseCode = manifestInfo === null ? '' : manifestInfo.notifyEnterpriseCode
        addr.notifyEnterpriseName = manifestInfo === null ? '' : manifestInfo.notifyEnterpriseName
        addr.notifyAddress = manifestInfo === null ? '' : manifestInfo.notifyAddress
        addr.notifyContactsType = manifestInfo === null ? 0 : manifestInfo.notifyContactsType
        addr.notifyContacts = manifestInfo === null ? '' : manifestInfo.notifyContacts
        addr.notifyCityName = manifestInfo === null ? '' : manifestInfo.notifyCityName
        addr.notifyProvinceCode = manifestInfo === null ? '' : manifestInfo.notifyProvinceCode
        addr.notifyProvinceName = manifestInfo === null ? '' : manifestInfo.notifyProvinceName
        addr.notifyZipCode = manifestInfo === null ? '' : manifestInfo.notifyZipCode
        addr.notifyCountryCode = manifestInfo === null ? '' : manifestInfo.notifyCountryCode
        addr.notifyAeoEnterpriseCode = manifestInfo === null ? '' : manifestInfo.notifyAeoEnterpriseCode
      }
    }

    if (view.$refs.shipperLine1) {
      addr.shipperLine1 = view.$refs.shipperLine1.value
      addr.shipperLine2 = view.$refs.shipperLine2.value
      addr.shipperLine3 = view.$refs.shipperLine3.value
      addr.shipperLine4 = view.$refs.shipperLine4.value
      addr.shipperLine5 = view.$refs.shipperLine5.value
      addr.shipperLine6 = view.$refs.shipperLine6.value
      // 增加第 7 行
      if (view.$refs.shipperLine7) {
        addr.shipperLine7 = view.$refs.shipperLine7.value
      }
    }

    if (view.$refs.consigneeLine1) {
      addr.consigneeLine1 = view.$refs.consigneeLine1.value
      addr.consigneeLine2 = view.$refs.consigneeLine2.value
      addr.consigneeLine3 = view.$refs.consigneeLine3.value
      addr.consigneeLine4 = view.$refs.consigneeLine4.value
      addr.consigneeLine5 = view.$refs.consigneeLine5.value
      addr.consigneeLine6 = view.$refs.consigneeLine6.value
      // 增加第 7 行
      if (view.$refs.consigneeLine7) {
        addr.consigneeLine7 = view.$refs.consigneeLine7.value
      }
    }

    if (view.$refs.notifyLine1) {
      addr.notifyLine1 = view.$refs.notifyLine1.value
      addr.notifyLine2 = view.$refs.notifyLine2.value
      addr.notifyLine3 = view.$refs.notifyLine3.value
      addr.notifyLine4 = view.$refs.notifyLine4.value
      addr.notifyLine5 = view.$refs.notifyLine5.value
      addr.notifyLine6 = view.$refs.notifyLine6.value
      // 增加第 7 行
      if (view.$refs.notifyLine7) {
        addr.notifyLine7 = view.$refs.notifyLine7.value
      }
    }
    BillAddress.checkBillAddress(addr.getData()).then(res => {
      this.checkBillAddressResultHandler()
    }).catch(() => {
      this.commonFaultHandler()
    })
  }
  jobSaveCheck() {
    const job = this.job
    if (!job) { return }
    if (job.customerId === 0) { return }

    const addr = new BillAddress().fillDefaultValue()
    addr.billHistoryType = 0
    addr.partnerId = job.customerId
    addr.lob = job.lob
    addr.officeId = $store.getters.currentOfficeId

    addr.shipperLine1 = job.shipperLine1
    addr.shipperLine2 = job.shipperLine2
    addr.shipperLine3 = job.shipperLine3
    addr.shipperLine4 = job.shipperLine4
    addr.shipperLine5 = job.shipperLine5
    addr.shipperLine6 = job.shipperLine6

    addr.consigneeLine1 = job.consigneeLine1
    addr.consigneeLine2 = job.consigneeLine2
    addr.consigneeLine3 = job.consigneeLine3
    addr.consigneeLine4 = job.consigneeLine4
    addr.consigneeLine5 = job.consigneeLine5
    addr.consigneeLine6 = job.consigneeLine6

    addr.notifyLine1 = job.notifyLine1
    addr.notifyLine2 = job.notifyLine2
    addr.notifyLine3 = job.notifyLine3
    addr.notifyLine4 = job.notifyLine4
    addr.notifyLine5 = job.notifyLine5
    addr.notifyLine6 = job.notifyLine6

    const data = addr.getData()
    data.preConfigured = true
    BillAddress.checkBillAddress(data).then(res => {
      this.checkBillAddressResultHandler()
    }).catch(() => {
      this.commonFaultHandler()
    })
  }
  syncMasterMBLByJob() { // 同步主票主单
  // todo-shengsheng  Desc:
  // this.job.syncMasterMBLByJob(job, syncMasterMBLByJobResultHandler, commonFaultHandler);
  }

  /**
 * 清空字段内容
 */
  clearInput(type) {
    for (let i = 1; i < 7; i++) {
      if (this._view.hasOwnProperty(type + i)) {
        this._view[type + i] = ''
      }
    }
  }

  sendFunctionClickLog(type) {
    let content = ''
    const copyAddrType = this.copyAddrType
    if (type === 'shipper') {
      if (copyAddrType === 'SE') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-${this.view.$t('SeaExport.Basic')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyShipper')})`
      }
      if (copyAddrType === 'MBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-MBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyShipper')})`
      }
      if (copyAddrType === 'HBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-HBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyShipper')})`
      }
      if (content) {
        // LogStores.sendFunctionClickLogStoresByLabel(content)
      }
    }
    if (type === 'consignee') {
      content = ''
      if (copyAddrType === 'SE') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-${this.view.$t('SeaExport.Basic')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyConsignee')})`
      }
      if (copyAddrType === 'MBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-MBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyConsignee')})`
      }
      if (copyAddrType === 'HBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-HBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyConsignee')})`
      }
      if (content) {
      // LogStores.sendFunctionClickLogStoresByLabel(content);
      }
    }
    if (type === 'notify') {
      content = ''
      if (copyAddrType === 'SE') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-${this.view.$t('SeaExport.Basic')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyNotify')})`
      }
      if (copyAddrType === 'MBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-MBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyNotify')})`
      }
      if (copyAddrType === 'HBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-HBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(${this.view.$t('SeaExport.CopyNotify')})`
      }
      if (content) {
      // LogStores.sendFunctionClickLogStoresByLabel(content);
      }
    }
    if (type) {
      content = ''
      if (copyAddrType === 'SE') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-${this.view.$t('SeaExport.Basic')}-${this.view.$t('SeaExport.TransceiverSelection')}(选择)`
      }
      if (copyAddrType === 'MBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-MBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(选择)`
      }
      if (copyAddrType === 'HBL') {
        content = `${this.view.$t('CargoMsg.Cargo_OceanExport')}-HBL-${this.view.$t('SeaExport.CodeSearching')}-${this.view.$t('SeaExport.TransceiverSelection')}(选择)`
      }
      if (content) {
      // LogStores.sendFunctionClickLogStoresByLabel(content);
      }
    }
  }

  checkBillAddressResultHandler(result) {
    // cargo 没有提示 Message.success('checkBillAddress Success!')
  }
  syncMasterMBLByJobResultHandler(result) {
    Message.success('syncMasterMBLByJob Success!')
  }
  commonFaultHandler(fault) {
    Message.error('fail')
  // LOGGER.error("Request Eror:"+ fault.fault.toString());
  // FlexGlobals.topLevelApplication.status = "错误产生!";
  }
}
